import { ReactNode } from "react";

type CsStatCardProps = {
  label: string;
  value: ReactNode;
  sub?: ReactNode;
};

export const CsStatCard = ({ label, value, sub }: CsStatCardProps) => (
  <div className="t-bg-surface t-border t-border-solid t-border-neutral-10 t-rounded-lg t-p-4 t-flex t-flex-col t-gap-1">
    <p className="t-m-0 t-text-caption t-font-medium t-uppercase t-tracking-widest t-text-text-30">
      {label}
    </p>
    <div className="t-text-h4 t-font-bold t-leading-none t-text-text-100">
      {value}
    </div>
    {sub && (
      <div className="t-text-body-sm t-text-text-30 t-flex t-items-center t-gap-1 t-flex-wrap">
        {sub}
      </div>
    )}
  </div>
);
